// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"8c9d81f238bfa9aa7810e73d11d1508e97d41bdc"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "15.5.3";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

const isSentryFrontEnabled =
  process.env.NEXT_PUBLIC_SENTRY_FRONT_ENABLED === 'true'

const excludedTransactions = [
  '/mag/[[...catchall]]',
  '/organizers/[[...catchall]]',
  '/timers/[[...catchall]]'
]

if (isSentryFrontEnabled) {
  Sentry.init({
    dsn: 'https://66166f962bd54e52ac80c29406ebda3d@o4505369890652160.ingest.sentry.io/4505488215769088',
    integrations: [Sentry.browserTracingIntegration()],
    beforeSend(event) {
      if (excludedTransactions.includes(event.transaction ?? '')) {
        return null
      }
      return event
    }
  })
}
